import React, { useEffect, useState, useRef } from "react";
import { Play, Pause, Volume2 } from "lucide-react";
import api from "@/lib/api";

/**
 * VoiceIntro — plays a short recorded welcome from Isa if one has been uploaded by admin.
 * Data source: GET /api/site-settings (voice_intro_url + voice_intro_caption). Silent if empty.
 */
export default function VoiceIntro() {
  const [settings, setSettings] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    api.get("/site-settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  if (!settings || !settings.voice_intro_url) return null;

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) { a.pause(); setPlaying(false); }
    else { a.play(); setPlaying(true); }
  };
  const onTime = () => {
    const a = audioRef.current;
    if (a && a.duration) setProgress((a.currentTime / a.duration) * 100);
  };

  return (
    <div data-testid="voice-intro" className="inline-flex items-center gap-4 rounded-full border border-forest-900/10 bg-white/70 backdrop-blur px-3 py-2 pr-6 shadow-[0_10px_30px_rgba(44,62,53,0.08)]">
      <button
        onClick={toggle}
        data-testid="voice-intro-toggle"
        aria-label={playing ? "Pause" : "Play"}
        className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-forest-800 text-ivory transition hover:bg-forest-900"
      >
        {playing ? <Pause className="h-4 w-4" strokeWidth={1.5} /> : <Play className="h-4 w-4 ml-0.5" strokeWidth={1.5} />}
      </button>
      <div className="flex flex-col">
        <span className="text-[10px] uppercase tracking-[0.28em] text-wheat-700 flex items-center gap-1.5">
          <Volume2 className="h-3 w-3" strokeWidth={1.5} /> A word from Isa
        </span>
        <span className="text-sm text-forest-800 font-medium max-w-[18rem] truncate">{settings.voice_intro_caption || "A short welcome."}</span>
        <div className="mt-1 h-0.5 w-40 bg-forest-900/10 rounded-full overflow-hidden">
          <div className="h-full bg-wheat-500 transition-[width] duration-200" style={{ width: `${progress}%` }} />
        </div>
      </div>
      <audio
        ref={audioRef}
        src={settings.voice_intro_url}
        onTimeUpdate={onTime}
        onEnded={() => { setPlaying(false); setProgress(0); }}
        preload="metadata"
        data-testid="voice-intro-audio"
      />
    </div>
  );
}
